<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">function</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Personalizar Fórmulas</h2>
        <span class="modal-subtitle">{{ data.titulo }}</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">

    <app-alert-card type="warning" title="Atenção ao personalizar fórmulas" class="mb-3 d-block">
        {{ data.mensagemAlerta ?? 'A personalização das fórmulas altera como o motor fiscal calcula esta configuração. Certifique-se de que as expressões personalizadas estão corretas antes de salvar. A responsabilidade pelo cálculo customizado é do usuário.' }}
    </app-alert-card>

    <div class="formulas-list">
        @for (formula of formulasPersonalizaveis; track formula.chaveFormula) {
        <app-formula-card [formula]="formula" [modo]="modoEditor" [estado]="getEstado(formula.chaveFormula)" [mostrarVigencia]="data.mostrarVigencia !== false" [mostrarBadgeModelo]="data.mostrarBadgeModelo !== false"
            (estadoChange)="onEstadoChange($event)">
        </app-formula-card>
        }
    </div>

    @if (formulasPersonalizaveis.length === 0) {
    <app-empty-state
        icon="function"
        title="Nenhuma fórmula personalizável disponível"
        subtitle="Não há fórmulas personalizáveis disponíveis para esta configuração.">
    </app-empty-state>
    }

</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    @if (personalizadasCount > 0) {
    <span class="status-badge personalizadas-badge" [ngClass]="badgeClasses.personalizada">{{ personalizadasCount }} personalizada(s)</span>
    }
    <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Cancelar</button>
    <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isValidando"
        [disabled]="!temAlteracoes || isValidando" [attr.aria-label]="isValidando ? 'Validando fórmulas' : 'Confirmar personalização'"
        (click)="salvar()">
        Confirmar personalização
        @if (isValidando) { <mat-spinner diameter="20"></mat-spinner> }
    </button>
</mat-dialog-actions>
